import { clsx } from "clsx";
import { useState } from "react";
import { Icon } from "../icon/Icon";
import styles from "./Checkbox.module.css";

interface CheckboxProps {
  id?: string;
  name?: string;
  checked?: boolean;
  highlight?: boolean;
  blink?: boolean;
  disabled?: boolean;
  required?: boolean;
  error?: Error;
  onChange?: (checked: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  checked,
  highlight,
  blink,
  disabled,
  required,
  error,
  onChange,
}) => {
  const [lastError, setLastError] = useState<Error>();

  return (
    <label
      className={clsx(
        styles.checkbox,
        highlight && styles.highlight,
        blink && styles.blink,
        error !== undefined && error !== lastError && styles.invalid,
      )}
      htmlFor={id}
    >
      <input
        id={id}
        className={styles["checkbox-input"]}
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        required={required}
        onChange={(event) => {
          onChange?.(event.target.checked);
          setLastError(error);
        }}
      />
      <Icon className={styles["checkbox-icon"]} name="check_box_24px" />
    </label>
  );
};
